export const SECOND_IN_MS: number = 1000;
export const MINUTE_IN_SECONDS: number = 60;
export const MONTHS_IN_YEAR: number = 12;

export const DAYJS_THRESHOLDS = [
  { l: 'ss', r: 59, d: 'second' },
  { l: 'hh', r: 23, d: 'hour' },
];

export const DAYJS_LOCAL_CONFIG = {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%d seconds',
    ss: '%d seconds',
    m: '1 minute',
    mm: '%d minutes',
    h: '1 hour',
    hh: '%d hours',
    d: '1 day',
    dd: '%d days',
    M: '1 month',
    MM: '%d months',
    y: '1 year',
    yy: '%d years',
  },
};
